import MaterialTable, { MTableCell, MTableToolbar } from '@material-table/core'
import { Button, IconButton, Link, Menu, MenuItem, Typography } from '@material-ui/core'
import { makeStyles, MuiThemeProvider } from '@material-ui/core/styles'
import { ArrowBackIosOutlined, ArrowForwardIosOutlined, CalendarToday } from '@material-ui/icons'
import { KeyboardDatePicker } from '@material-ui/pickers'
import clsx from 'clsx'
import moment from 'moment'
import React, { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link as RouterLink } from 'react-router-dom'

import { getPetAge, getDepartingInfo } from '../../services/helpers'
import { table } from '../../services/theme'
import { timeFormat } from '../../utils'

const useStyles = makeStyles((theme) => ({
	headerButton: {
		fontFamily: 'Nunito',
		fontWeight: '700',
		'& .MuiButton-label': {
			lineHeight: '19px',
			fontSize: '14px'
		}
	},
	addClientButton: {
		color: theme.palette.secondary.main,
		borderColor: theme.palette.secondary.main,
		padding: '7px 40px 8px 24px',
		'& .MuiButton-label': {
			'& .MuiButton-startIcon': {
				marginRight: 16
			}
		}
	},
	toolbarWrapper: {
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: '#F9F9F9'
	},
	petStatusIcon: {
		position: 'absolute',
		left: 0
	},
	toolbarExtras: {
		display: 'flex',
		'& > *': {
			marginRight: '16px'
		}
	},
	toolbar: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		padding: '0px 12px',
		'& > div:nth-child(1)': {
			'& > div:nth-child(4)': {
				flex: 'auto'
			}
		}
	},
	toolbar2: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		paddingBottom: 16,
		paddingTop: 12
	},
	barText: {
		fontWeight: '800',
		fontSize: 14,
		color: '#6B4AD6',
		width: '50%',
		textAlign: 'center',
		whiteSpace: 'nowrap'
	},
	barOuter: {
		width: '23%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		marginRight: 12
	},
	bar: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		paddingLeft: 16,
		paddingRight: 16,
		border: '1px solid #5F38BE',
		borderRadius: 6
	},
	datePickerContainer: {
		display: 'flex',
		alignItems: 'center',
		position: 'relative'
	},
	datePicker: {
		color: '#FFFFFF',
		opacity: 0,
		position: 'absolute',
		top: 0,
		height: 38,
		margin: 0,
		'& *': {
			height: 0,
			padding: 0,
			margin: 0
		}
	},
	calendarButton: {
		'& svg': {
			fill: theme.palette.primary.main
		}
	},
	calendarHeaderButtons: {
		fill: theme.palette.primary.main
	},
	calendarDateButton: {
		zIndex: 1,
		border: '1px solid #D0CFD2',
		padding: '7px 16px 8px 24px',
		color: '#4D4C4F',
		fontWeight: '700',
		'& .MuiButton-label': {
			'& .MuiButton-endIcon': {
				marginLeft: 16
			},
			whiteSpace: 'nowrap'
		}
	},
	dateChangeButton: {
		border: '1px solid #D0CFD2',
		height: 38,
		width: 38,
		padding: 5,
		'& svg': {
			height: 16
		}
	},
	addAppointmentButton: {
		color: theme.palette.secondary.main,
		borderColor: theme.palette.secondary.main,
		padding: '7px 40px 8px 24px',
		'& .MuiButton-label': {
			'& .MuiButton-startIcon': {
				marginRight: 16
			}
		}
	},
	tables: {
		display: 'flex',
		width: '100%',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: 10,
		paddingRight: 15,
		paddingLeft: 15
	},
	timeTable: {
		width: '24%',
		backgroundColor: '#F3F3F3',
		borderRadius: 6,
		display: 'flex',
		flexDirection: 'column',
		padding: 14,
		justifyContent: 'flex-start',
		'& h4': {
			marginTop: 0,
			marginBottom: 5,
			textTransform: 'capitalize',
			fontFamily: 'Nunito',
			fontWeight: '800',
			fontSize: 16
		}
	},
	xButton: {
		minWidth: 20,
		width: 35,
		fontWeight: '800',
		fontSize: 12,
		color: '#5F38BE'
	},
	timeRow: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		marginBottom: 5,
		padding: 4,
		width: '100%',
		'& span': {
			textTransform: 'capitalize',
			fontFamily: 'Nunito',
			fontWeight: '600',
			fontSize: 14
		}
	},
	timeRowLight: {
		backgroundColor: '#F9F9F9',
		borderRadius: 6
	},
	chipRow: {
		height: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center'
	},
	spacer: {
		margin: '5px 16px 5px 0px',
		width: '24px',
		position: 'relative',
		'&:before': {
			content: "''",
			position: 'absolute',
			height: '1px',
			width: '100%',
			top: 'calc(50% - 1px)',
			left: 0,
			backgroundColor: '#F3F3F3'
		}
	},
	boxRow: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		'& i': {
			marginRight: 17,
			color: '#D0CFD2'
		},
		'& .checked': {
			color: '#6B4AD6'
		}
	},
	boxBox: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'center'
	},
	location: {
		padding: 5,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		'& i': {
			marginRight: 10,
			color: '#777679'
		},
		'& span': {
			fontFamily: 'Nunito',
			fontSize: 16,
			lineHeight: '19px',
			fontWeight: '600',
			color: '#1A1A35'
		}
	},
	characteristics: {
		display: 'flex',
		alignItems: 'center'
	},
	chip: {
		background: 'rgba(107, 74, 214, 0.1)',
		backgroundColor: 'rgba(107, 74, 214, 0.1)',
		color: theme.palette.primary.main
	}
}))

export const UnassignedTable = (props) => {
	const classes = useStyles()

	const facility = useSelector((state) => state.specific.facilities.selected)
	let playgroups = (facility && facility.playgroups) || []

	const [isOpen, setIsOpen] = useState(false)
	const [bestFitFilter, setBestFitFilter] = useState(null)
	const [altFitFilter, setAltFitFilter] = useState(null)
	const [otherFitFilter, setOtherFitFilter] = useState(null)

	let { date, setDate, changeDate, unassigned_pets, selectPet, selected, visits, setFilteredPetIds } = props

	const updateDate = (date) => {
		setDate(moment(date).format('ll'))
		setIsOpen(false)
	}

	useEffect(() => {
		const filtered = filteredPets()
		setFilteredPetIds(filtered.map((p) => p._id))
	}, [bestFitFilter, altFitFilter, otherFitFilter])

	const filteredPets = () => {
		const filtered = unassigned_pets
			.filter((p) => {
				if (!bestFitFilter) return true
				if (bestFitFilter === 'None') return !p.best_fit_playgroup_type
				return p.best_fit_playgroup_type === bestFitFilter
			})
			.filter((p) => {
				if (!altFitFilter) return true
				if (altFitFilter === 'None') return !p.alt_playgroup_type
				return p.alt_playgroup_type === altFitFilter
			})
			.filter((p) => {
				if (!otherFitFilter) return true
				if (otherFitFilter === 'None')
					return !p.other_playgroup_types || !p.other_playgroup_types.filter(Boolean).length
				return p.other_playgroup_types && p.other_playgroup_types.includes(otherFitFilter)
			})

		return filtered
	}

	const getPetName = (pet) => {
		if (pet) {
			let name = pet.name
			let primary

			let visit = visits.find((v) => v.pet_ids.includes(pet._id))

			if (visit && visit.household && visit.household.accounts && visit.household.accounts.length) {
				primary = visit.household.accounts.find((a) => a.primary)

				primary = primary ? primary : visit.household.accounts[0]

				name = `${name}${primary && primary.last_name ? ` ${primary.last_name}` : ''}`
			}
			return name
		}
	}

	const renderPet = (pet) => {
		if (pet) {
			let name = getPetName(pet)

			let location
			let visit = visits.find((v) => v.pet_ids.includes(pet._id))
			let status = visit && visit.pet_status ? visit.pet_status.find((s) => s.pet_id === pet._id) : null
			if (status) {
				if (status.checked_in) {
					location = status.location ? status.location : 'In Facility'
				} else {
					location = 'Offsite'
				}
			} else {
				location = 'Offsite'
			}

			return (
				<div style={{}}>
					<div className={classes.boxRow}>
						<i
							className={selected.includes(pet._id) ? 'fa fa-check-square checked' : 'far fa-square'}
						/>
						<Link
							component={RouterLink}
							style={{
								textTransform: 'capitalize',
								color: '#6B4AD6',
								fontWeight: 600,
								fontSize: '16px',
								lineHeight: '22px'
								// whiteSpace: 'nowrap',
								// overflow: 'hidden',
								// textOverflow: 'ellipsis'
							}}
							onClick={(e) => e.stopPropagation()}
							to={`/clients/${pet.household_id}/pets/${pet._id}`}>
							{name}
						</Link>
					</div>
					<div className={classes.location}>
						<i className="fa fa-map-marker-alt" />
						<span>{location}</span>
					</div>
				</div>
			)
		}
	}

	const select = (id) => {
		let pets
		if (selected.includes(id)) {
			pets = selected.filter((s) => s !== id)
		} else {
			pets = [...selected, id]
		}
		selectPet(pets)
	}

	const getPreferences = (pet) => {
		let pref = pet.best_fit_playgroup
		let group = playgroups.find((g) => g._id == pref)
		let alts = ''
		if (pet.alt_playgroups) {
			let alternates = pet.alt_playgroups.map((pref) => {
				return playgroups.find((g) => g._id == pref)
			})
			alternates.forEach((a, i) => {
				if (i < alternates.length - 1) {
					alts += `${a.name}, `
				} else {
					alts += a.name
				}
			})
		}

		if (!pref && !alts) return ''
		return `${group.name}${alts.length ? ` || ${alts}` : ''}`
	}

	const renderBestFit = (pet) => {
		let text = '---'
		let { playgroup_types } = facility
		if (playgroup_types && pet.best_fit_playgroup_type) {
			let group = playgroup_types.find((t) => t._id === pet.best_fit_playgroup_type)
			if (group) text = group.name
		}
		return (
			<Typography variant="body1" style={{ fontSize: 14 }}>
				{text}
			</Typography>
		)
	}

	const renderAlternate = (pet) => {
		let text = '---'
		let { playgroup_types } = facility
		if (playgroup_types && pet.alt_playgroup_type) {
			let group = playgroup_types.find((t) => t._id === pet.alt_playgroup_type)
			if (group) text = group.name
		}

		return (
			<Typography variant="body1" style={{ fontSize: 14 }}>
				{text}
			</Typography>
		)
	}

	const renderFlex = (pet) => {
		let text = '---'
		let { playgroup_types } = facility
		if (playgroup_types && pet.other_playgroup_types) {
			text = ''
			pet.other_playgroup_types.forEach((type, i) => {
				let group = playgroup_types.find((t) => t._id === type)
				if (group && i < pet.other_playgroup_types.length - 1) {
					text += `${group.name}, `
				} else if (group) {
					text += `${group.name}`
				} else {
					text = '---'
				}
			})
		}

		return (
			<Typography variant="body1" style={{ fontSize: 14 }}>
				{text || '---'}
			</Typography>
		)
	}

	const renderCharacteristics = (pet) => {
		let size = getSize(pet)
		let age = pet.birthday ? getPetAge(pet.birthday) : null
		return (
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'flex-start',
					alignItems: 'flex-start'
				}}>
				<Typography variant="body1" style={{ fontSize: 14, textTransform: 'capitalize' }}>
					PS: {pet.play_style || '---'}
				</Typography>
				<Typography variant="body1" style={{ fontSize: 14, textTransform: 'uppercase' }}>
					S: {size || '---'}
				</Typography>
				<Typography variant="body1" style={{ fontSize: 14 }}>
					A: {age || '---'}
				</Typography>
			</div>
		)
	}

	const renderCubbies = (data) => {
		if (data && data.length) {
			return (
				<Typography variant="body1" style={{ fontSize: 14, width: '130px' }}>
					<span>{data.join('-')}</span>
				</Typography>
			)
		}
	}

	const getSize = (pet) => {
		if (pet.height) return pet.height
		if (pet.weight <= 12) {
			return 'xs'
		} else if (pet.weight >= 13 && pet.weight < 31) {
			return 's'
		} else if (pet.weight >= 31 && pet.weight < 48) {
			return 'm'
		} else if (pet.weight >= 48 && pet.weight < 71) {
			return 'l'
		} else if (pet.weight >= 71) {
			return 'xl'
		} else {
			return null
		}
	}

	const getFlexString = (pet) => {
		let text = ''
		let { playgroup_types } = facility
		if (playgroup_types && pet.other_playgroup_types) {
			let groups = pet.other_playgroup_types
				.map((type, i) => {
					let group = playgroup_types.find((t) => t._id === type)
					return group?.name || ''
				})
				.filter(Boolean)

			groups.sort()
			if (groups.length) text = groups[0]
		}

		return text || ''
	}

	const getBestFitString = (pet) => {
		let text = ''
		let { playgroup_types } = facility
		if (playgroup_types && pet.best_fit_playgroup_type) {
			let group = playgroup_types.find((t) => t._id === pet.best_fit_playgroup_type)
			text = group?.name || ''
		}

		return text || ''
	}

	const getAltString = (pet) => {
		let text = ''
		let { playgroup_types } = facility
		if (playgroup_types && pet.alt_playgroup_type) {
			let group = playgroup_types.find((t) => t._id === pet.alt_playgroup_type)
			text = group?.name || ''
		}

		return text || ''
	}

	const renderDetails = (data) => {
		let everyPetHasStatus = data.pet_ids.every((id) => data.pet_status.find((s) => s.pet_id === id))
		let hasArrivingPets =
			data.status && data.status.id && data.status.id > 4 && (data.status.id > 4 || data.status.id === 5)
				? false
				: !everyPetHasStatus ||
				  (everyPetHasStatus &&
						moment(data.startDate).isSame(date, 'date') &&
						data.pet_status.some((s) => !s.checked_in && !s.checked_out))

		let headingText = ''
		let timeText = ''

		let dropOffBegin =
			data.type === 'boarding' && !data.first_day_daycare
				? '17:00'
				: facility?.services?.daycare?.dropoff_begins
		let dropOffDeadline =
			data.type === 'boarding' && !data.first_day_daycare
				? '21:00'
				: facility?.services?.daycare?.dropoff_deadline
		let pickUpDeadline =
			data.type === 'boarding' && !data.last_day_daycare
				? facility?.services?.boarding?.pickup_deadline
				: facility?.services?.daycare?.pickup_deadline

		if (hasArrivingPets) {
			headingText = 'Arriving'
			if (data.early_dropoff) {
				dropOffBegin = '06:00'
				dropOffDeadline = '07:00'
			} else if (data.time_block === 'afternoon') {
				dropOffBegin = '12:00'
				dropOffDeadline = '14:00'
			} else if (data.time_block === 'evening') {
				dropOffBegin = '18:30'
				dropOffDeadline = '19:30'
			}
			timeText =
				dropOffBegin && dropOffDeadline
					? `${moment(dropOffBegin, 'HH:mm').format(timeFormat(dropOffBegin))} - ${moment(
							dropOffDeadline,
							'HH:mm'
					  ).format(timeFormat(dropOffDeadline))}`
					: ''
		}

		const prms = {
			headingText,
			timeText,
			date,
			pickUpDeadline
		}

		const departVals = getDepartingInfo(data, prms)
		timeText = departVals.timeText
		headingText = departVals.headingText

		return (
			<Fragment>
				{headingText ? <Typography variant="caption">{headingText}</Typography> : null}
				{timeText ? (
					<Typography variant="caption" style={{ color: '#777679', display: 'block' }}>
						{timeText}
					</Typography>
				) : null}
			</Fragment>
		)
	}

	const handleAppRightClick = (e, prms) => {
		e.preventDefault()
		const url = `/clients/${prms.household_id}/appointments/${prms._id}${`?date=${prms.date}`}`
		const win = window.open(url, '_blank')
		win.focus()
	}

	const renderAppointment = (data) => {
		const visit = visits.find((v) => v.pet_ids.includes(data._id) && v.type !== 'grooming')
		if (!visit) return null

		const formattedDate = moment(props.date).format('YYYYMMDD')
		const appPrms = {
			_id: visit._id,
			household_id: visit.household_id,
			date: formattedDate
		}
		return (
			<div onContextMenu={(e) => handleAppRightClick(e, appPrms)}>
				<Typography variant="caption" style={{ textTransform: 'capitalize' }}>
					{visit.type === 'compatibility_session' ? 'Compatibility Session' : visit.type}
				</Typography>
				<Typography variant="caption" style={{ color: '#777679', display: 'block' }}>
					{renderDetails(visit)}
				</Typography>
			</div>
		)
	}

	return (
		<MuiThemeProvider theme={table}>
			<MaterialTable
				scheduleAggregates={props.scheduleAggregates}
				date={props.date}
				options={{
					headerStyle: {
						color: '#1A1A35',
						textTransform: 'uppercase',
						fontWeight: 800,
						fontSize: '12px',
						lineHeight: '16px',
						padding: '11px 24px',
						borderTop: '1px solid #D0CFD2',
						backgroundColor: '#F9F9F9'
					},
					rowStyle: {
						verticalAlign: 'top',
						fontSize: 16
					},
					pageSize: 20,
					pageSizeOptions: [10, 20, 50],
					toolbarButtonAlignment: 'left',
					searchFieldAlignment: 'left',
					searchFieldVariant: 'filled',
					height: 500
				}}
				columns={[
					{
						title: 'Pet',
						render: (data) => renderPet(data),
						customFilterAndSearch: (value, rowData) => {
							if (!value) return true
							return rowData.name.toLowerCase().includes(value.toLowerCase())
						},
						customSort: (a, b) => {
							return getPetName(a).localeCompare(getPetName(b))
						},
						width: 215,
						cellStyle: {
							paddingLeft: 24,
							paddingTop: 24,
							paddingRight: 0,
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'flex-start',
							flexDirection: 'column'
						}
					},
					{
						title: 'Appointment',
						field: 'type',
						render: (data) => renderAppointment(data),
						customSort: (a, b) => {
							let visitA = visits.find((v) => v.pet_ids.includes(a._id))
							let visitB = visits.find((v) => v.pet_ids.includes(b._id))

							return visitA.type.localeCompare(visitB.type)
						}
					},
					{
						title: 'Cubbies',
						sorting: false,
						render: (data) => {
							const { cubbies: petCubbies = {} } = data

							const {
								gear: gearFac,
								food: foodFac,
								boarding: boardingFac,
								medication: medicationFAc
							} = facility?.cubbies || {}

							const cubbies = []

							for (const petCubby in petCubbies) {
								if (Object.hasOwn(petCubbies, petCubby)) {
									let prefix = ''
									if (petCubby === 'gear') {
										prefix = gearFac?.prefix || 'G'
									} else if (petCubby === 'food') {
										prefix = foodFac?.prefix || 'F'
									} else if (petCubby === 'medication') {
										prefix = medicationFAc?.prefix || 'M'
									} else if (petCubby === 'boarding') {
										prefix = boardingFac?.prefix || 'B'
									} else {
										continue
									}
									const cubbyNum = petCubbies[petCubby]
									if (cubbyNum !== null) {
										cubbies.push(`${prefix}${petCubbies[petCubby]}`)
									}
								}
							}

							return cubbies.length > 0 ? renderCubbies(cubbies) : 'N/A'
						}
					},
					{
						title: 'BEST FIT',
						render: (data) => renderBestFit(data),
						customSort: (a, b) => {
							return getBestFitString(a).localeCompare(getBestFitString(b))
						}
					},
					{
						title: 'ALTERNATE',
						render: (data) => renderAlternate(data),
						customSort: (a, b) => {
							return getAltString(a).localeCompare(getAltString(b))
						}
					},
					{
						title: 'FLEX',
						render: (data) => renderFlex(data),
						customSort: (a, b) => {
							return getFlexString(a).localeCompare(getFlexString(b))
						}
					},
					{
						title: 'CHARACTERISTICS',
						render: (data) => renderCharacteristics(data),
						sorting: false
					}
				]}
				data={filteredPets()}
				onRowClick={(e, pet) => {
					select(pet._id)
				}}
				components={{
					Cell: (props) => (
						<MTableCell
							style={{
								borderBottom: 'none',
								padding: '16px 36px 16px 24px'
							}}
							{...props}
						/>
					),
					Toolbar: (props) => (
						<div className={classes.toolbarWrapper}>
							<div className={classes.toolbar}>
								<MTableToolbar {...props} />
								<div className={classes.toolbarExtras}>
									<div className={classes.datePickerContainer}>
										<Button
											className={clsx(classes.headerButton, classes.calendarDateButton)}
											onClick={() => setIsOpen(true)}
											variant="outlined"
											endIcon={
												<CalendarToday
													style={{ height: 19, width: 19, fill: '#777679' }}
												/>
											}
											size="large">
											{date}
										</Button>
										<KeyboardDatePicker
											disableToolbar
											open={isOpen}
											onOpen={() => setIsOpen(true)}
											onClose={() => setIsOpen(false)}
											variant="inline"
											format="MM/DD/YYYY"
											margin="normal"
											id="start-date"
											label="Start Date"
											inputVariant="filled"
											value={date}
											onChange={updateDate}
											className={classes.datePicker}
											rightArrowIcon={
												<ArrowForwardIosOutlined
													className={classes.calendarHeaderButtons}
												/>
											}
											leftArrowIcon={
												<ArrowBackIosOutlined className={classes.calendarHeaderButtons} />
											}
											KeyboardButtonProps={{
												'aria-label': 'Start Date',
												className: classes.calendarButton
											}}
										/>
									</div>
									<IconButton
										className={classes.dateChangeButton}
										onClick={() => changeDate('subtract')}>
										<ArrowBackIosOutlined style={{ fill: '#777679' }} />
									</IconButton>
									<IconButton
										className={classes.dateChangeButton}
										onClick={() => changeDate('add')}>
										<ArrowForwardIosOutlined style={{ fill: '#777679' }} />
									</IconButton>
								</div>
							</div>
							<div className={classes.toolbar2}>
								<Typography
									variant="body2"
									style={{ margin: 16, fontSize: 12, fontWeight: '800' }}>
									FILTER BY
								</Typography>
								<div className={classes.barOuter}>
									<div className={classes.bar}>
										<Typography variant="body2" className={classes.barText}>
											BEST FIT
										</Typography>
										<MenuThing
											value={bestFitFilter}
											onChange={setBestFitFilter}
											playgroupTypes={facility.playgroup_types}
											isBestFit={true}
										/>
									</div>
									<Button
										variant="text"
										className={classes.xButton}
										onClick={() => setBestFitFilter(null)}>
										X
									</Button>
								</div>
								<div className={classes.barOuter}>
									<div className={classes.bar}>
										<Typography variant="body2" className={classes.barText}>
											ALTERNATE
										</Typography>
										<MenuThing
											value={altFitFilter}
											onChange={setAltFitFilter}
											playgroupTypes={facility.playgroup_types}
											isBestFit={false}
										/>
									</div>
									<Button
										variant="text"
										className={classes.xButton}
										onClick={() => setAltFitFilter(null)}>
										X
									</Button>
								</div>
								<div className={classes.barOuter}>
									<div className={classes.bar}>
										<Typography variant="body2" className={classes.barText}>
											FLEX
										</Typography>
										<MenuThing
											value={otherFitFilter}
											onChange={setOtherFitFilter}
											playgroupTypes={facility.playgroup_types}
											isBestFit={false}
										/>
									</div>
									<Button
										variant="text"
										className={classes.xButton}
										onClick={() => setOtherFitFilter(null)}>
										X
									</Button>
								</div>
							</div>
						</div>
					)
				}}
				title="Unassigned Dogs"
			/>
		</MuiThemeProvider>
	)
}

const MenuThing = ({ playgroupTypes, value, onChange, isBestFit }) => {
	const [anchorEl, setAnchorEl] = React.useState(null)
	const [text, setText] = useState('No Selection')
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget)
	}

	const handleClose = () => {
		setAnchorEl(null)
	}

	useEffect(() => {
		if (value === null) {
			setText('No Selection')
		} else if (value === 'None') {
			setText('None')
		} else if (value) {
			let group = playgroupTypes.find((g) => g._id === value)
			setText(group.name)
		}
	}, [value, playgroupTypes])

	return (
		<React.Fragment>
			<Button
				variant="text"
				aria-controls="simple-menu"
				aria-haspopup="true"
				style={{
					color: '#777679',
					fontSize: 16,
					fontWeight: '400',
					width: '100%',
					textTransform: 'capitalize',
					position: 'relative',
					display: 'flex',
					flexDirection: 'row'
				}}
				onClick={handleClick}>
				<span
					style={{
						whiteSpace: 'nowrap',
						overflow: 'hidden',
						textOverflow: 'ellipsis'
					}}>
					{text}
				</span>
				<i
					className={anchorEl ? 'fas fa-caret-up' : 'fas fa-caret-down'}
					style={{
						color: '#6B4AD6',
						fontSize: 20,
						paddingLeft: 16,
						position: 'absolute',
						right: -4,
						top: 8
					}}
				/>
			</Button>
			<Menu
				id="simple-menu"
				anchorEl={anchorEl}
				getContentAnchorEl={null}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				transformOrigin={{ vertical: 'top', horizontal: 'center' }}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}>
				<div
					style={{
						height: 270,
						width: 275,
						overflowY: 'scroll',
						borderBottom: '1px solid #D0CFD2'
					}}>
					{isBestFit ? null : (
						<MenuItem
							key={`value33355`}
							value="None"
							onClick={() => onChange('None')}
							style={{ fontSize: 16, fontWeight: '600', color: '#1A1A35' }}>
							<i
								className={value === 'None' ? 'fas fa-scrubber' : 'far fa-scrubber'}
								style={{ color: value === 'None' ? '#6B4AD6' : '#D0CFD2', margin: 12 }}
							/>
							None
						</MenuItem>
					)}
					{playgroupTypes.map((type, id) => (
						<MenuItem
							key={`value${type.number}-${id}`}
							value={type._id}
							onClick={() => onChange(type._id)}
							style={{ fontSize: 16, fontWeight: '600', color: '#1A1A35' }}>
							<i
								className={value === type._id ? 'fas fa-scrubber' : 'far fa-scrubber'}
								style={{ color: value === type._id ? '#6B4AD6' : '#D0CFD2', margin: 12 }}
							/>
							{type.name}
						</MenuItem>
					))}
				</div>
				<MenuItem
					style={{
						letterSpacing: 0.75,
						width: 275,
						padding: 18,
						paddingBottom: 14,
						color: '#6B4AD6',
						textTransform: 'uppercase',
						fontSize: 12,
						fontWeight: '800'
					}}
					onClick={() => onChange(null)}>
					Clear Selection
				</MenuItem>
			</Menu>
		</React.Fragment>
	)
}
